import { useContext } from "react";
import { CreateRequestContext } from "./context";

const useCreateRequestContext = () => {
  return useContext(CreateRequestContext);
};

export { useCreateRequestContext };
